import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicationUpdatePage = {
  alert: {
    error: 'application-update-page.alert.error',
    signInLink: 'application-update-page.alert.signin-link',
    signUpLink: 'application-update-page.alert.signup-link',
  },
  footer: {
    root: 'application-update-page.footer.root',
  },
  form: {
    h1: 'application-update-page.form.heading1',
    h2: 'application-update-page.form.heading2',
    phoneInput: 'application-update-page.form.phone-input',
    phoneInputError: 'application-update-page.form.phone-error',
    root: 'application-update-page.form.root',
    submitButton: 'application-update-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
